import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import i18n from "../i18n";
import TranslateIcon from "@mui/icons-material/Translate";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { Button, Menu, Dropdown } from "antd";
import MenuItem from "antd/es/menu/MenuItem";
import "./Styles/Language.css";

const Language = () => {
  const { t } = useTranslation();
  const [language, setLanguage] = useState(Cookies.get("language") || "en");

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
    i18n.changeLanguage(lang);
    Cookies.set("language", lang);
  };

  useEffect(() => {
    i18n.changeLanguage(language);
    document.documentElement.lang =
      language === "ku" || language === "ar" ? language : "en";
  }, [language]);

  const languages = [
    { code: "en", label: t("English") },
    { code: "ku", label: t("Kurdish") },
    { code: "ar", label: t("Arabic") },
  ];

  const languageMenu = (
    <Menu className="language-menu">
      {languages.map(({ code, label }) => (
        <MenuItem
          key={code}
          onClick={() => handleLanguageChange(code)}
          className={
            language === code
              ? "language-menu-item is-active"
              : "language-menu-item"
          }
        >
          {label}
        </MenuItem>
      ))}
    </Menu>
  );

  return (
    <div>
      {/* Language Selection Button */}
      <Dropdown overlay={languageMenu} trigger={["click"]}>
        <Button
          icon={<TranslateIcon />}
          shape="circle"
          size="large"
          className="scroll-to-top-button"
          style={{
            position: "fixed",
            bottom: "20px",
            right: "20px",
            backgroundColor: "#1976d2",
            color: "white",
            zIndex: 1000,
            transition: "all 0.3s ease",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            border: "none",
            width: "48px",
            height: "48px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "&:hover": {
              backgroundColor: "#1565c0",
              transform: "translateY(-2px)",
              boxShadow: "0 6px 16px rgba(0,0,0,0.2)",
            },
          }}
        />
      </Dropdown>

      {/* WhatsApp Contact Chat */}
      <Button
        type="primary"
        className="whatsapp-button"
        onClick={() => window.open("https://wa.me/9647811421542", "_blank")}
        style={{
          position: "fixed",
          bottom: "20px",
          right: "80px",
          backgroundColor: "#25D366",
          color: "white",
          zIndex: 1000,
          width: "48px",
          height: "48px",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          border: "none",
          transition: "all 0.3s ease",
          "&:hover": {
            backgroundColor: "#128C7E",
            transform: "translateY(-2px)",
            boxShadow: "0 6px 16px rgba(0,0,0,0.2)",
          },
        }}
      >
        <WhatsAppIcon fontSize="large" />
      </Button>
    </div>
  );
};

export default Language;
